import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Skeleton, Empty, Button, message, Tag, Table, Card } from 'antd';
import { getById } from '../../../../apis/BajaEmpleadoApi';
import { getAll as getAllFiniquitos } from '../../../../apis/FiniquitoApi';
import ModalCambiarEstatus from './editar-estaus';
import AddOrEdit from './AddOrEdit';
import {estatus_baja} from '../../../../constants/bajaEmpleado';



const FiniquitoDetail = ({visible, onClose, recordId, recordData, updateRecordData}) => {
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [liquidaciones, setLiquidaciones] = useState([]);
    const [modalEstatusVisible, setModalEstatusVisible] = useState(false);
    const [addOrEditVisible, setAddOrEditVisible] = useState(false);
    const [finiquitoSelected, setFiniquitoSelected] = useState(false);

    useEffect(() => {
        if (visible && recordId) {
            loadDetailData();
        }
    }, [visible, recordId]);

    const loadDetailData = async () => {
        setLoading(true);
        try {
            const response = await getById(recordId);
            if (response.ok) {
                setDetailData(response.payload);
            } else {
                message.error('Error al cargar la información detallada');
                setDetailData(null);
                return;
            }
            const responseFiniquitos = await getAllFiniquitos(recordId);
            if (responseFiniquitos.ok) {
                setLiquidaciones(responseFiniquitos.payload);
            } else {
                message.error('Error al cargar la información detallada');
                setDetailData(null);
            }
            
        } catch (error) {
            message.error('Error al obtener el detalle del registro');
            setDetailData(null);
        } finally {
            setLoading(false);
        }
    };


    const handleClose = () => {
        setDetailData(null);
        setLiquidaciones([]);
        setModalEstatusVisible(false);
        setAddOrEditVisible(false); 
        onClose();
    };

    const getStatusTag = (status) => {
        const statusMap = {
            1: { color: '#faad14', text: 'Pendiente' },
            2: { color: '#2db7f5', text: 'Proceso' },
            3: { color: '#722ed1', text: 'Calculado' },
            4: { color: '#13c2c2', text: 'Afectado' },
            5: { color: '#52c41a', text: 'Pagado' },
            6: { color: '#eb2f96', text: 'Timbrado' },
            7: { color: '#8c8c8c', text: 'Cancelado' },
            0: { color: '#f50', text: 'Error' }
        };

        const statusInfo = statusMap[status] || { color: 'default', text: 'Desconocido' };
        return <Tag color={statusInfo.color}>{statusInfo.text}</Tag>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        } catch {
            return 'Fecha inválida';
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return '$0.00';
        return `$${amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 60,
            align: 'center'
        },
        {
            title: 'Tipo liquidación',
            dataIndex: 'tipo_liquidacion',
            key: 'tipo_liquidacion',
            width: 120,
            align: 'center',
            render: (tipo_liquidacion) => {
                return <Tag color={'default'}>
                    {tipo_liquidacion.displayTitle}
                </Tag>
            }
        },
        {
            title: 'Motivo Baja',
            dataIndex: 'motivo_baja',
            key: 'motivo_baja',
            width: 120,
            align: 'center',
            render: (motivo_baja) => {
                return <Tag color={'default'}>
                    {motivo_baja.displayTitle}
                </Tag>
            }
        },
        {
            title: 'Monto Neto',
            dataIndex: 'neto_pagar',
            key: 'neto_pagar',
            width: 120,
            align: 'right',
            render: (value) => formatCurrency(value)
        },
        {
            title: 'Definitivo',
            dataIndex: 'definitivo',
            key: 'definitivo',
            width: 80,
            align: 'center',
            render: (value, record) => (
                <Tag color={value === true ? 'green' : 'default'}>
                    {value == true?'Si': 'No'}
                </Tag>
            )
        },
        {
            title: 'Acciones',
            key: 'acciones',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <Button 
                    type="primary" 
                    size="small"
                    onClick={() => handleEdit(record)}
                    disabled={detailData.status == estatus_baja.AFECTADO && record.definitivo == false}
                >
                    Editar
                </Button>
            )
        }
    ];

    const handleEdit = (record) => {
        debugger;
        setFiniquitoSelected(record);
        setAddOrEditVisible(true);
        // message.info(`Editando liquidación ${record.num}: ${record.descripcion}`);
    };

    const handleCambiarEstatus = () => {
        setModalEstatusVisible(true);
    };

    const handleCloseModalEstatus = () => {
        setModalEstatusVisible(false);
    };

    const handleStatusChange = (newStatus, comentario) => {
        if (detailData) {
            setDetailData({
                ...detailData,
                status: newStatus
            });
        }
    };

    const handleRevisarDocumentos = () => {
        message.info('Revisar documentos');
    };

    const handleNuevo = () => {
        setAddOrEditVisible(true);
    };

    const handleSaveNuevaLiquidacion = (nuevaLiquidacion) => {
        const nuevoId = liquidaciones.length + 1;
        const liquidacionConId = {
            ...nuevaLiquidacion,
            key: nuevoId,
            num: nuevoId
        }; 
        setLiquidaciones([...liquidaciones, liquidacionConId]);
        message.success('Liquidación agregada exitosamente');
    }

    const handleUpdateFiniquitos = async (bajaEstatus) => {
        debugger;
        await loadDetailData();
        await updateRecordData({id: recordData.id, status: bajaEstatus});
    }

    const handleCloseModalNuevaLiquidacion = () => {
        setAddOrEditVisible(false);
        setFiniquitoSelected(null);
    };

    const renderContent = () => {
        if (loading) {
            return <Skeleton loading={true} active paragraph={{ rows: 8 }} />;
        }

        if (!detailData) {
            return <Empty description="No se pudo cargar la información" />;
        }

        const selectedLiquidacion = liquidaciones.find(liq => liq.definitivo === 'Si');

        return (
            <div>
                {/* Sección superior - Información del empleado */}
                <Card 
                    title="Información del Empleado" 
                    size="small" 
                    style={{ marginBottom: 16 }}
                >
                    <Form layout="vertical" size="small">
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item label="Empleado" style={{ marginBottom: 8 }}>
                                    <Row gutter={8}>
                                        <Col span={12}>
                                            <Input 
                                                placeholder="Numero"
                                                value={detailData.nomina_employee_number || ''} 
                                                disabled 
                                                size="small"
                                            />
                                        </Col>
                                        <Col span={12}>
                                            <Input 
                                                placeholder="Nombre"
                                                value={detailData.empleado || ''} 
                                                disabled 
                                                size="small"
                                            />
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Fecha Baja" style={{ marginBottom: 8 }}>
                                    <Input 
                                        placeholder="dd/mm/yyyy"
                                        value={formatDate(detailData.move_date)} 
                                        disabled 
                                        size="small"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item label="Estatus" style={{ marginBottom: 8 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {getStatusTag(detailData.status)}
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <div style={{ display: 'flex', gap: 8, marginTop: 24 }}>
                                    <Button 
                                        type="primary" 
                                        size="small"
                                        onClick={handleCambiarEstatus}
                                    >
                                        Cambiar Estatus
                                    </Button>
                                    <Button 
                                        size="small"
                                        onClick={handleRevisarDocumentos}
                                    >
                                        Revisar Documentos
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Card>

                {/* Sección inferior - Tabla de liquidaciones */}
                <Card 
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Liquidaciones</span>
                            <Button 
                                type="primary" 
                                size="small"
                                disabled={detailData.status == estatus_baja.AFECTADO}
                                onClick={handleNuevo}
                            >
                                Nuevo
                            </Button>
                        </div>
                    }
                    size="small"
                >
                    <Table
                        columns={columns}
                        dataSource={liquidaciones}
                        pagination={false}
                        size="small"
                        scroll={{ y: 300 }}
                        rowClassName={(record) => 
                            record.definitivo === 'Si' ? 'selected-row' : ''
                        }
                    />
                </Card>

                <style jsx>{`
                    .selected-row {
                        background-color: #fff7e6 !important;
                    }
                    .selected-row:hover {
                        background-color: #fff7e6 !important;
                    }
                `}</style>
            </div>
        );
    };

    return (
        <>
            <Modal
                title={
                    <div>
                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            Información
                        </span>
                        {recordData && (
                            <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                                {recordData.empleado} - ID: {recordData.odoo_id}
                            </div>
                        )}
                    </div>
                }
                open={visible}
                onCancel={handleClose}
                width={1100}
                footer={[
                    <Button key="refresh" onClick={loadDetailData} loading={loading}>
                        Actualizar
                    </Button>,
                    <Button key="close" type="primary" onClick={handleClose}>
                        Cerrar
                    </Button>
                ]}
                style={{ top: 20 }}
                bodyStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
            >
                {renderContent()}
            </Modal>

            {/* Modal para cambiar estatus */}
            <ModalCambiarEstatus
                visible={modalEstatusVisible}
                onClose={handleCloseModalEstatus}
                currentStatus={detailData?.status}
                empleadoData={detailData}
                onStatusChange={handleStatusChange}
            />

            {/* Modal para nueva liquidación */}
            {
                addOrEditVisible && !finiquitoSelected &&
                <AddOrEdit
                    visible={true}
                    onClose={handleCloseModalNuevaLiquidacion}
                    bajaData={detailData}
                    recordId={recordId}
                    finiquitoId={null}
                    onSave={handleSaveNuevaLiquidacion}
                    update={handleUpdateFiniquitos}
                />
            }
            {
                addOrEditVisible && finiquitoSelected && 
                <AddOrEdit
                    visible={true}
                    onClose={handleCloseModalNuevaLiquidacion}
                    bajaData={detailData}
                    recordId={recordId}
                    finiquitoId={finiquitoSelected.id}
                    onSave={handleSaveNuevaLiquidacion}
                    update={handleUpdateFiniquitos}
                />
            }
            
        </>
    );
}
export default FiniquitoDetail;